<template>
  <div
    v-if="loaded"
    class="c-short-hero"
  >
    <div class="l-container">
      <template v-if="backgroundImage && backgroundImage.src">
        <div
          class="c-short-hero__image-container"
        >
          <img
            :src="backgroundImage.src"
            :alt="backgroundImage.alt || title"
            class="c-short-hero__image"
          >
        </div>
        <div class="c-short-hero__content l-flex l-flex--column">
          <h1
            v-if="title"
            class="t-heading-3 u-margin-bottom-x-small"
          >
            {{ title }}
          </h1>
          <p
            v-if="subtitle"
            class="c-hero__subtitle t-heading-6 u-margin-bottom-x-small"
          >
            {{ subtitle }}
          </p>
          <wysiwyg
            v-if="description && !plpHero.variant2"
            :html="description"
          />
        </div>
      </template>
      <div
        v-else
        class="c-short-hero__content c-short-hero__content--no-image l-flex l-flex--column u-100-height"
      >
        <h1
          v-if="title"
          class="t-heading-3 u-margin-bottom-x-small"
        >
          {{ title }}
        </h1>
        <p
          v-if="subtitle"
          class="c-hero__subtitle t-heading-6 u-margin-bottom-x-small"
        >
          {{ subtitle }}
        </p>
        <wysiwyg
          v-if="description && !plpHero.variant2"
          :html="description"
        />
      </div>
    </div>
  </div>
  <div v-else>
    <loader />
  </div>
</template>

<script>
import Loader from "../loader/Loader";
import Wysiwyg from "../wysiwyg/Wysiwyg";
import abTesting from '@mixins/abTesting';

export default {
  components: {
    Loader,
    Wysiwyg
  },
  mixins: [
    abTesting
  ],
  props: {
    title: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    desktopBackgroundImage: {
      type: Object,
      default: () => ({
        src: '',
        alt: 'desktopBackgroundImage'
      })
    },
    mobileBackgroundImage: {
      type: Object,
      default: () => ({
        src: '',
        alt: 'mobileBackgroundImage'
      })
    },
  },
  data() {
    return {
      backgroundImage: null
    }
  },
  computed: {
    loaded() {
      for (var key in this.$props) {
        if (this.$props[key] !== null) {
          if (this.$props[key]['default'] !== null) {
            return true;
          }
        }
      }
      return false;
    },
    plpHero() {
      const abTesting = this.abTesting
      let result = { default: true }
      if(abTesting)
      {
        const store = this.$store
        if (
          store &&
          store.state &&
          store.state.vwo &&
          store.state.vwo.plpHero
        ) {
          result = store.state.vwo.plpHero
        }
      }
      return result
    }
  },
  created() {
    try {
      window.addEventListener("resize", this.updateBackgroundImage);
    } catch (err) {
      // console.log('window not loaded');
    }
  },
  mounted() {
    this.updateBackgroundImage();
  },
  destroyed() {
    try {
      window.removeEventListener("resize", this.updateBackgroundImage);
    } catch (err) {
      // console.log('window not loaded');
    }
  },
  methods: {
    updateBackgroundImage() {
      if (window.innerWidth <= 1200) {
        if (this.mobileBackgroundImage) {
          this.backgroundImage = this.mobileBackgroundImage;
        }
      } else {
        if (this.desktopBackgroundImage) {
          this.backgroundImage = this.desktopBackgroundImage;
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .c-short-hero {
    position: relative;
    overflow: hidden;
    &__image-container {
      @include respond(tab-port) {
        transform: translateX(-23%);
        overflow: hidden;
        border-radius: 50%;
        width: 180%;
        margin-top: -25%;
        position: relative;
        &:before {
          content: "";
          padding-bottom: 65%;
          display: block;
        }
      }
    }

    &__image {
      right: 0;
      position: absolute;
      z-index: -1;
      top: 50%;
      transform: translateY(-50%);
      @include respond(tab-port) {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        min-height: 0;
        max-width: none;
      }
    }
    &__content {
      position: relative;
      padding: rem(5px) 0;
      max-width: rem(376px);
      height: 300px;
      @include respond(tab-port) {
        height: auto;
      }

      align-items: flex-start;
      z-index: 1;

      &--no-image {
        position: relative;
        max-width: rem(900px);
        padding: rem(20px) 0;
      }

      &:before {
        content: "";
        background-color: #fbffff;
        position: absolute;
        min-height: rem(790px);
        top: 50%;
        transform: translateY(-50%);
        bottom: -70%;
        right: -80px;
        left: -100%;
        z-index: -1;
        border-radius: 50%;
        height: 210%;
      }
      @include respond(tab-port) {
        position: relative;
        margin: auto;
        text-align: center;
        align-items: center;
        &:before {
          display: none;
        }
      }
    }
  }
</style>
